import { createContext, useContext, type ReactNode } from 'react';
import { sporsmaalssti, veiledningssti, type Hjelperamme } from '../lib/hjelpesider';

/**
 * Hvilken ramme hjelpesidene står i: inne i appen, eller åpent for alle.
 *
 * Se `Hjelperamme` i `lib/hjelpesider.ts`. Konteksten finnes for at de samme
 * sidene og de samme tekstene skal kunne lenke riktig fra begge steder uten å
 * få rammen sendt inn som en egenskap gjennom hvert ledd – kapittellenka i et
 * avsnitt tre nivåer nede skal vite det like godt som menyen.
 *
 * Standarden er appen. Da er alt som ikke er pakket inn, slik det alltid har
 * vært, og det er bare den offentlige rammen som må si fra om seg selv.
 */
const HjelperammeContext = createContext<Hjelperamme>('app');

export function HjelperammeProvider({
  ramme,
  children,
}: {
  ramme: Hjelperamme;
  children: ReactNode;
}) {
  return <HjelperammeContext.Provider value={ramme}>{children}</HjelperammeContext.Provider>;
}

export function useHjelperamme(): {
  ramme: Hjelperamme;
  /** Sant når leseren ikke er inne i appen, og kanskje ikke har konto. */
  offentlig: boolean;
  veiledningssti: (slug: string) => string;
  sporsmaalssti: string;
} {
  const ramme = useContext(HjelperammeContext);
  return {
    ramme,
    offentlig: ramme === 'offentlig',
    veiledningssti: (slug) => veiledningssti(slug, ramme),
    sporsmaalssti: sporsmaalssti(ramme),
  };
}
